import React from 'react';
import { Container, Input } from '@design-system';
import { BiMinus, BiPlus } from 'react-icons/bi';
import './QuantityPicker.scss';

export type QuantityPickerProps = {
    quantity: number;
    onQuantityChange: (quantity: number) => void;
    size?: 'small' | 'medium';
    min?: number;
    max?: number;
};

export const QuantityPicker: React.FC<QuantityPickerProps> = ({ quantity, onQuantityChange, min = 0, max = 999, size = 'medium' }) => {
    const handleIncrement = () => {
        if (quantity < max) {
            onQuantityChange(quantity + 1);
        }
    };

    const handleDecrement = () => {
        if (quantity > min) {
            onQuantityChange(quantity - 1);
        }
    };

    return (
        <Container className={`quantity-picker ${size}`} padding="none" center>
            <div className="quantity-button decrease" onClick={handleDecrement}>
                <BiMinus />
            </div>
            <Input
                className="quantity-input"
                value={quantity.toString()}
                onValueChange={(value: string) => onQuantityChange(Number(value))}
                placeholder="Quantité"
                type="number"
            />
            <div className="quantity-button increase" onClick={handleIncrement}>
                <BiPlus />
            </div>
        </Container>
    );
};
